import {obj_forEach_f, obj_toArray_fo} from "../../../functions/src/shareCode/Share_S_Obj";

import {
    FB_UserData,
} from "../../../functions/src/shareCode/Share_S_Classes";

import {
    http_database_getOnce_f,
    http_database_updateData_f,
    http_endPointPath_oa,
    http_database_onValueListener_open_f,
    http_database_onValueListener_close_f,
    http_auth_resetPassword_fp,
    http_auth_fetchProvidersForEmail_fp,
    http_auth_signIn_facebook_fp,
    http_auth_signIn_google_fp,
    http_auth_signIn_anonymously_fp,
    http_auth_signIn_emailAndPass_fp,
    http_auth_logout,
    http_storage_uploadFile_f,
    http_functions_fp,
    http_auth_signIn_linkEmailPass_fp,
} from "./S_HttpRequests";
import {
    store_listener_remove_f,
    store_listener_set_f,
    store_var
} from "@/store";
import {enum_loginMethods} from "../../../functions/src/shareCode/Share_S_Enum";
import {webAppManager_getProviderToken_fp} from "@/scripts/S_WebAppMediator";

let lastUserData_c = undefined

// serverAuth_currentUserData_get_vl_fp
export const serverAuth_currentUserData_get_vl_fp = (viewName_s, cb_f) => {

    return new Promise((resolve, reject) => {
        store_listener_set_f(store_var.fb_auth, viewName_s, (fbAuth_c) => {

            if(fbAuth_c != null){
                cb_f(undefined)

                http_database_onValueListener_open_f({
                    viewName_s: viewName_s,
                    path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(fbAuth_c.fa_userId_uid),
                    cacheFallback_b : true,
                    cb_f    : (userData_o) => {
                        // cb_f(userData_o)

                        // change user => clean prev user
                        if(lastUserData_c && lastUserData_c.ud_userId_uid !== fbAuth_c.fa_userId_uid){
                            http_database_onValueListener_close_f({path_as: http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(lastUserData_c.ud_userId_uid), viewName_s: viewName_s})
                            lastUserData_c = null
                        }

                        // update currentLastUser
                        if(userData_o == null){
                            lastUserData_c = null
                        }else{
                            // user exist in DB
                            lastUserData_c = new FB_UserData(userData_o)
                        }

                        // cb_f
                        cb_f(lastUserData_c)
                        resolve(lastUserData_c)
                    }
                })
            }else{
                // logout
                if(lastUserData_c){
                    http_database_onValueListener_close_f({path_as: http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(lastUserData_c.ud_userId_uid), viewName_s: viewName_s})
                    lastUserData_c = null
                }
                cb_f(null)
                resolve(null)
            }
        })
    })

}
export const serverAuth_currentUserData_remove_vl_f = (viewName_s) => {

    store_listener_remove_f(store_var.fb_auth, viewName_s)
    if(lastUserData_c){
        http_database_onValueListener_close_f({path_as: http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(lastUserData_c.ud_userId_uid), viewName_s: viewName_s})
        lastUserData_c = null
    }
}

// serverAuth_guestLogin_fp
export const serverAuth_login_guest_fp = () => {
    return http_auth_signIn_anonymously_fp()
}

// serverAuth_login_google_fp
export const serverAuth_login_google_fp = (tokenId_uid) => {

    return webAppManager_getProviderToken_fp(enum_loginMethods.google)
        .then(googleIdToken_s => {
            return http_auth_signIn_google_fp(googleIdToken_s, tokenId_uid)
        }).catch( (ans_o) => {
            throw ans_o.error.message
        })
}

// serverAuth_login_facebook_fp
export const serverAuth_login_facebook_fp = (fbTokenId_uid) => {

    return webAppManager_getProviderToken_fp(enum_loginMethods.facebook)
        .then((accessToken_s) => {
            return http_auth_signIn_facebook_fp(accessToken_s, fbTokenId_uid)
        })

}

// serverAuth_login_emailPass_existingUser_fp
export const serverAuth_linkEmailPass_fp = (fbIdToken_s, email_s, password_s, loginMethods_ae) => {

    return http_auth_signIn_linkEmailPass_fp(fbIdToken_s, email_s, password_s)
        .then((fbAuth_c) => {
            return new Promise( (resolve, reject)=> {
                http_database_updateData_f({
                    path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(fbAuth_c.fa_userId_uid).concat(FB_UserData.ud_l_loginMethods_ae),
                    data_c : loginMethods_ae,
                    cb_f : () => {resolve()}
                })
            })
        })
}

// serverAuth_login_emailPass_existingUser_fp
export const serverAuth_login_emailPass_fp = ({email_s, password_s, newUser_b}) => {
    return http_auth_signIn_emailAndPass_fp(email_s.toLowerCase(), password_s, newUser_b)
}

// serverAuth_fetchProvidersForEmail_fp
export const serverAuth_fetchProvidersForEmail_fp = (email_s) => {
    return http_auth_fetchProvidersForEmail_fp(email_s)
}

// serverAuth_getOtherUserData_withEmail_f
export const serverAuth_getOtherUserData_withEmail_fp = (email_s) => {

    return new Promise(resolve =>
        http_database_getOnce_f({
            path_as: http_endPointPath_oa.DATABASE_MAIN_USERS_DATA,
            query_os: {
                orderBy: FB_UserData.ud_label_email_s,
                equalTo: email_s,
            },
            cb_f: (userData_bid_o => {

                if(userData_bid_o == null){
                    resolve(null)
                    return
                }

                let userData_ao = obj_toArray_fo(userData_bid_o)

                if(userData_ao.length <= 0){
                    resolve(null)
                    return
                }

                resolve(new FB_UserData(userData_ao[0]))
            })
        })

    )


    // return http_functions_fp({
    //     path_as: http_endPointPath_oa.FUNCTIONS_endPoint_getUserDataWithEmail_f,
    //     data_c: {email_s: email_s.toLowerCase()}
    // }).then((userData_bid_o) => {
    //
    //     console.log(userData_bid_o)
    //
    //     if(userData_bid_o == null){
    //         return null
    //     }
    //
    //     let userData_ao = obj_toArray_fo(userData_bid_o)
    //
    //     if(userData_ao.length <= 0){
    //         return null
    //     }
    //
    //     return new FB_UserData(userData_ao[0])
    //
    // })

}

// serverAuth_logout_fp
export const serverAuth_logout_fp = (cb_f) => {
    http_auth_logout(cb_f)
}

// serverAuth_currentUserData_update_f
export const serverAuth_currentUserData_update_f = (userData_c, cb_f) => {

    // upload file
    http_storage_uploadFile_f({
        file_c : userData_c.ud_avatar_c.cuda_imgFile_c,
        path_as: http_endPointPath_oa.STORAGE_USERS_DATA.concat(userData_c.ud_userId_uid),
        cb_f : () => {

            http_database_updateData_f({
                path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(userData_c.ud_userId_uid),
                data_c : userData_c,
                cb_f : cb_f,
            })
        }
    })
}

// serverAuth_userData_email_update_f
export const serverAuth_userData_email_update_f = (userData_c, cb_f) => {

    http_database_updateData_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(userData_c.ud_userId_uid),
        data_c : {
            [FB_UserData.ud_label_email_s] : userData_c.ud_email_s,
        },
        cb_f : cb_f,
    })

}

// serverAuth_currentUserLangCode_update_f
export const serverAuth_currentUserLangCode_update_f = (userId_uid, langCode_e, cb_f) => {

    http_database_updateData_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(userId_uid),
        data_c : {
            ud_langCode_e : langCode_e,
        },
        cb_f : cb_f,
    })

}

// server_getOtherUserData_fp
export const serverAuth_getOtherUserData_f = (userId_uid, cb_f) => {


    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(userId_uid),
        cb_f    : (userData_o) => {
            cb_f(userData_o != null ? new FB_UserData(userData_o) : new FB_UserData({ud_userId_uid: userId_uid}))
        }
    })

}

// server_resetPassword_f
export const serverAuth_resetPassword_fp = (email_s) => {
    return http_auth_resetPassword_fp(email_s)
}

// server_createWithEmailAndPassword_f
export const serverAuth_createWithEmailAndPassword_f = ({email_s, password_s, username_s, langCode_e, phone_s, avatar_c, cb_f, cbError_f}) => {
    //
    // let userEmailLowerSplit_as = email_s.toLowerCase().split('@')
    // let userEmailLower_s = `${userEmailLowerSplit_as[0].replace(/\./g, "")}@${userEmailLowerSplit_as[1]}`
    //
    //
    // const ref_storage_o = REF_STORAGE_USERS_DATA.child(userEmailLower_s)
    //
    // // 1) upload avatar if exist
    // console.log("1) upload file", avatar_c)
    // storage_uploadFbClassFiles_f(avatar_c, ref_storage_o, () => {
    //
    //     console.log("2) create user", avatar_c)
    //
    //     // 2) create user
    //     functions_callHttps(
    //         REF_FUNCTIONS_HTTPS_users_createNewUserData,
    //         {
    //             email_s : userEmailLower_s,
    //             password_s : password_s,
    //             username_s : username_s,
    //             phone_s : phone_s,
    //             langCode_e : langCode_e,
    //             avatar_o : avatar_c,
    //         },
    //         (userdata_o) => {
    //
    //             console.log("3) login", userdata_o)
    //
    //             if(userdata_o != null){
    //                 // 3) sign in
    //                 serverAuth_login_emailPass_newUser_fp({
    //                     email_s     : userEmailLower_s,
    //                     password_s  : password_s,
    //                     cb_f        : (authUser_o) => {
    //                         cb_f(userdata_o)
    //                     },
    //                     cbError_f   : cbError_f
    //                 })
    //             }
    //         })
    // })


    // auth_createUserWithEmailAndPassword(
    //     email_s,
    //     password_s,
    //     (UserCredential) => {
    //
    //         auth_updateProfile_f({
    //             displayName: username_s,
    //         }).then((user) => {
    //
    //             http_database_updateData_f({
    //                 path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA.concat(UserCredential.user.uid),
    //                 data_c : {
    //                     ud_name_s       : username_s,
    //                     ud_langCode_e   : langCode_e,
    //                 },
    //                 cb_f : () => {},
    //             })
    //
    //
    //             if(phone_s){
    //                 serverPre_subUserData_moreInfo_update_f(
    //                     new FB_UserDataSub_MoreInfo({
    //                         udsmi_userId_uid    : UserCredential.user.uid,
    //                         udsmi_about_uid     : "",
    //                         udsmi_phone_s       : phone_s,
    //                     }),
    //                     (userMoreData_c) => {
    //
    //                     })
    //             }
    //
    //
    //         }).catch(function (error) {
    //             cbError_f(error)
    //         });
    //
    //         cb_f(UserCredential)
    //
    //     },
    //     cbError_f);
}

// serverAuth_checkIfUserExists_fp
export const serverAuth_checkIfUserExists_fp = (email, cb) => {

    return http_auth_fetchProvidersForEmail_fp(email, (providersArr) => {

        if (providersArr.length > 0) {
            cb(true)
        } else {
            cb(false)
        }
    })
}

// server_linkCredentialToCurrentUser
export const serverAuth_linkCredentialToCurrentUser_f = (credential) => {
    // auth_linkCredential(credential)
}

// server_getAllUsers_f
export const serverAuth_getAllUsers_f = (cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_MAIN_USERS_DATA,
        cb_f : (userData_byUserId_o) => {

            if(userData_byUserId_o == null){userData_byUserId_o = {}}

            obj_forEach_f(userData_byUserId_o, (userData_o, key) =>{
                if(userData_o!= null && userData_o.ud_userId_uid != null){
                    cb_f(new FB_UserData(userData_o))
                }else{
                    console.log(userData_o, key)
                }
            })

        }
    })


}

// serverAuth_updateUserAccessLevel_fp
export const serverAuth_updateUserAccessLevel_fp = (userData_c) => {

    console.log(userData_c)
    return http_functions_fp({
        path_as: http_endPointPath_oa.FUNCTIONS_endPoint_updateUserAccessLevel,
        data_c: {
            userId_uid: userData_c.ud_userId_uid,
            accessLevel_n: userData_c.ud_accessLevel_n,
            tqProfit_n: userData_c.ud_tqProfitPercentage_n,
        }
    })

}
